module.exports = __webpack_public_path__ + "img/registration.99ba0f2e.png";